import axios from 'axios';
import { MODULES_BASE_URLS } from 'src/common/constants';



export default class RiskAssessmentService {
	static instance;

	static getInstance() {
		if (!RiskAssessmentService.instance) {
			RiskAssessmentService.instance = new RiskAssessmentService();
		}

		return RiskAssessmentService.instance;
	}


    async acceptRisk(module, riskId, payload = {}) {
        const response = await axios.post(
            `${MODULES_BASE_URLS[module]}/risk/${riskId}/accept`,
            payload,
            {
                params: {},
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }
}
